import { useTranslation } from 'react-i18next';

import { useBillingNoteTemplates } from '@/billing/hooks/useBillingNoteTemplates';
import type { BillingNoteInput } from '@/billing/types/BillingNoteInput';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/common/components/ui/select';
import { Textarea } from '@/common/components/ui/textarea';

type BillingNoteTemplatePickerProps = {
  value?: BillingNoteInput;
  onChange: (value: BillingNoteInput) => void;
};

export const BillingNoteTemplatePicker = ({
  value,
  onChange,
}: BillingNoteTemplatePickerProps) => {
  const { t } = useTranslation();
  const { templates } = useBillingNoteTemplates();
  const isCustom = !!value && 'content' in value;

  return (
    <div>
      <Select
        value={isCustom ? 'custom' : String(value?.templateId ?? '')}
        onValueChange={(selection) =>
          onChange(
            selection === 'custom'
              ? { content: '' }
              : { templateId: Number(selection) },
          )
        }
      >
        <SelectTrigger
          className="w-full bg-background"
          aria-label={t('billing.notesHistory.predefined')}
        >
          <SelectValue placeholder={t('billing.notesHistory.addNote')} />
        </SelectTrigger>
        <SelectContent>
          {templates
            .filter((template) => template.isActive)
            .map((template) => (
              <SelectItem key={template.id} value={String(template.id)}>
                {template.label}
              </SelectItem>
            ))}

          <SelectItem value="custom">{t('billing.drawer.other')}</SelectItem>
        </SelectContent>
      </Select>

      {isCustom && (
        <Textarea
          className="bg-background! hover:bg-background/80 border-utility-gray-200 mt-2"
          placeholder={t('billing.drawer.enterComment')}
          aria-label={t('billing.drawer.enterComment')}
          value={value.content}
          onChange={(e) => onChange({ content: e.target.value })}
        />
      )}
    </div>
  );
};
